import * as $ from 'jquery';
import 'bootstrap';

export class imgTextContainer {
	$showmoredestBtn: any = $('.show-more--dest');
	$showmoredestination: any = $('.show-more--destinations');

	showmoredest(): void {
		let _self = this;
		let $totaldeals: any = $('.deals-content').length;

		let $limitDeals: any = $('.destination-container').attr('data-item--showonload');
		let $showItem:any = $('.destination-container .showing-txt .showing');
		let $totalDealsItem: any = $('.destination-container .showing-txt .total-destinations');

		$(".deals-content:lt("+$limitDeals+")").show();

		let $visibleDeals: any = $('.deals-content:visible').length;
		$showItem.html($visibleDeals);
		$totalDealsItem.html($totaldeals);

		if($visibleDeals < $limitDeals){
			_self.$showmoredestBtn.hide();
		} else {
			_self.$showmoredestBtn.show();
		}

		if($visibleDeals == $totalDealsItem){
			_self.$showmoredestBtn.hide();
		}

		_self.$showmoredestBtn.on('click', () =>{
			let $nextShowItems: any = $('.destination-container').attr('data-item--showeachclick');
			let $shown: any = $('.deals-content:visible').length+ parseInt($nextShowItems);
			if($shown < $totaldeals){
				$(".deals-content:lt("+$shown+")").show();
				let $visibleDeals: any = $('.deals-content:visible').length;
			$showItem.html($visibleDeals);
			$totalDealsItem.html($totaldeals);
			} else {
				$(".deals-content:lt("+$totaldeals+")").show();
				_self.$showmoredestBtn.hide();
				let $visibleDeals: any = $('.deals-content:visible').length;
			$showItem.html($visibleDeals);
			$totalDealsItem.html($totaldeals);
			}
		});
	}
}

let scope:Element = document.querySelector('.destination-container');
if (scope){
	try {
	let imgtextcontainer = new imgTextContainer();
			imgtextcontainer.showmoredest();
	} catch(e) {console.error(e);}
}
